import VerticalBookingCardBase from '../common/VerticalBookingCardBase';

function BookingCardGolf({ booking, updateBookingState }) {
  return (
    <VerticalBookingCardBase
      booking={booking}
      color='#ffffff'
      showProductInfo={true}
      showVariationInfo={true}
    />
  );
}

export default BookingCardGolf;
